export interface AppointmentTrainer {
  id?: string; // System.Guid
  appointmentId?: string; // System.Guid
  trainerId?: string; // System.Guid
  companyId?: string; // System.Guid
  createdDate: string; // System.DateTime
  creatorId?: string; // System.Guid

  // Additional Dto - fields
  isCheckedIn?: boolean;
  appointmentDate?: string; // System.DateTime
  appointmentTimeFrom?: string; // System.TimeSpan
  appointmentTimeTill?: string; // System.TimeSpan
  appointmentCountOfAttendances?: number;
  appointmentMaxAttendees?: number;
  appointmentCanceledDate?: string; // System.DateTime
  courseName?: string;
  courseActive?: boolean;
  locationName?: string;
  roomName?: string;
}

export interface Value {
  value: AppointmentTrainer[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<AppointmentTrainer>): any {
  return {
    Id: data?.id || undefined,
    AppointmentId: data?.appointmentId || undefined,
    TrainerId: data?.trainerId || undefined,
    CompanyId: data?.companyId || undefined,
  };
}

function parse(data?: Partial<AppointmentTrainer>): AppointmentTrainer {
  return {
    id: data?.id || undefined,
    appointmentId: data?.appointmentId || undefined,
    trainerId: data?.trainerId || undefined,
    companyId: data?.companyId || undefined,
    createdDate: data?.createdDate || '',
    creatorId: data?.creatorId || undefined,
    isCheckedIn: data?.isCheckedIn ?? false,
    appointmentDate: data?.appointmentDate || undefined,
    appointmentTimeFrom:
      data?.appointmentTimeFrom?.substring(0, 5) || undefined,
    appointmentTimeTill:
      data?.appointmentTimeTill?.substring(0, 5) || undefined,
    appointmentCountOfAttendances: data?.appointmentCountOfAttendances || 0,
    appointmentMaxAttendees: data?.appointmentMaxAttendees || 0,
    appointmentCanceledDate: data?.appointmentCanceledDate || undefined,
    courseName: data?.courseName || undefined,
    courseActive: data?.courseActive ?? false,
    locationName: data?.locationName || undefined,
    roomName: data?.roomName || undefined,
  };
}

export default {
  parse,
  toAPI: toAPI,
};
